import { render } from "./AddRecipientForm.vue?vue&type=template&id=35096550"
import script from "./AddRecipientForm.vue?vue&type=script&lang=js"
export * from "./AddRecipientForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__